import { useState } from 'react'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { getDepreciationVoucherPreview, postDepreciationVoucher } from '../service/investmentService'
import { showErrorMessage, showSuccessMessage } from '../../../utils/message'

export const useDepreciationVoucherPreview = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [voucherData, setVoucherData] = useState<any>(null)

  const fetchPreview = async (date: string) => {
    setIsLoading(true)
    try {
      const data = await getDepreciationVoucherPreview(companyId, date)
      setVoucherData(data)
      return data
    } catch (err: any) {
      showErrorMessage()
      throw err
    } finally {
      setIsLoading(false)
    }
  }

  const submitVoucher = async (date: string) => {
    setIsSubmitting(true)
    try {
      const result = await postDepreciationVoucher(companyId, date)
      showSuccessMessage()
      return result
    } catch (err: any) {
      showErrorMessage()
      throw err
    } finally {
      setIsSubmitting(false)
    }
  }

  const clearData = () => {
    setVoucherData(null)
  }

  return {
    fetchPreview,
    submitVoucher,
    isLoading,
    isSubmitting,
    voucherData,
    clearData
  }
}
